import React, { useState, useEffect } from "react";
import BuilderDefinition from "./BuilderDefinition";
import DeleteIcon from "../../../Common/components/Delete_icon";
import { Popover, PopoverBody, OverlayTrigger } from "react-bootstrap";
import RestoreIcon from "../../../Common/components/RestoreIcon";
import OverlayIcon from "Components/GMS/Rules/Components/OverlayIcon";
import { DISPLAY_NAME_INFO, UNIQUE_NAME_INFO } from "../SmartBuilderConstants";
import { toast } from "react-toastify";

const BuilderComponent = ({
  componentdetail,
  position,
  updateComponentList,
  removeComponentFromList,
  totalComponent,
  reorderComponent,
  preview_builder_Details,
  setComponentList,
  componentList,
}) => {
  const [display_name, setDisplay_name] = useState("");
  const [nessie, setNessie] = useState("");
  const [unique_name, setUnique_name] = useState("");
  const [description, setDescription] = useState("");
  const [definition, setDefinition] = useState(null);

  const [updatedComponent, setUpdatedComponent] = useState(componentdetail);

  const set_component_detail = (key, value) => {
    const {
      nessie,
      component: {
        display_name,
        unique_name,
        description,
        definition,
        is_deleted,
      },
      rank,
    } = updatedComponent;
    let isDelete = is_deleted ? true : false;
    const updatedComponentData = {
      nessie,
      rank,
      component: {
        display_name,
        unique_name,
        description,
        definition,
        is_deleted: isDelete,
      },
    };

    switch (key) {
      case "display_name":
        setDisplay_name(value);
        updatedComponentData.component.display_name = value;
        break;
      case "nessie":
        setNessie(value);
        updatedComponentData.nessie = value;
        break;
      case "unique_name":
        setUnique_name(value);
        updatedComponentData.component.unique_name = value;
        break;
      case "description":
        setDescription(value);
        updatedComponentData.component.description = value;
        break;
      case "definition":
        setDefinition(value);
        updatedComponentData.component.definition = JSON.stringify(value);
        break;
      case "is_deleted":
        updatedComponentData.component.is_deleted = !isDelete;
        break;
      default:
        console.log("outside the scope");
    }
    updateComponent(updatedComponentData, position);
  };

  function updateComponent(builder, pos) {
    setUpdatedComponent(builder);
    updateComponentList(builder, pos);
  }

  const removeComponent = (index) => {
    if (componentList.length === 1) {
      toast.error(
        "Cannot delete all components. At least one component must remain."
      );
      return;
    }
    removeComponentFromList(index);
  };

  useEffect(() => {
    if (componentdetail) {
      const {
        nessie,
        component: { display_name, unique_name, description, definition },
      } = componentdetail;
      setDisplay_name(display_name);
      setNessie(nessie);
      setUnique_name(unique_name);
      setDescription(description);
      setDefinition(
        definition && typeof definition === "string" && definition !== ""
          ? JSON.parse(definition)
          : ""
      );
    }
  }, [componentdetail]);

  const moveComponentUp = () => {
    reorderComponent(position, position - 1);
  };

  const moveComponentDown = () => {
    reorderComponent(position, position + 1);
  };

  return (
    <React.Fragment>
      {
        <div
          className="pt-3 pb-0 mb-4 rounded builder-border container-fluid position-relative ps-5"
          style={{
            background: "#f2f2f2",
            borderColor: componentdetail?.component?.is_deleted
              ? "#dc3545"
              : "#caccd0",
            boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.04)",
          }}
        >
          {position + 1 < totalComponent && (
            <OverlayTrigger
              trigger={["hover", "focus"]}
              placement="top"
              overlay={
                <Popover id="popover-component-display-name">
                  <PopoverBody
                    style={{
                      backgroundColor: "#000000",
                      color: "#ffffff",
                    }}
                  >
                    Move Component Down
                  </PopoverBody>
                </Popover>
              }
            >
              <button
                className="p-0 shadow-none btn"
                style={{
                  position: "absolute",
                  top: "-20px",
                  right: "13px",
                }}
                onClick={() => {
                  moveComponentDown();
                }}
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#ts3tfwq8qa)">
                    <rect
                      x="8"
                      y="6"
                      width="24"
                      height="24"
                      rx="4"
                      fill="#fff"
                    />
                    <rect
                      x="8.5"
                      y="6.5"
                      width="23"
                      height="23"
                      rx="3.5"
                      stroke="#C9CCCF"
                    />
                  </g>
                  <path
                    d="m16 16 4 4 4-4"
                    stroke="#091CAA"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <defs>
                    <filter
                      id="ts3tfwq8qa"
                      x="0"
                      y="0"
                      width="40"
                      height="40"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="2" />
                      <feGaussianBlur stdDeviation="4" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
                      <feBlend
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_522_1350"
                      />
                      <feBlend
                        in="SourceGraphic"
                        in2="effect1_dropShadow_522_1350"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </button>
            </OverlayTrigger>
          )}
          {position > 0 && (
            <OverlayTrigger
              trigger={["hover", "focus"]}
              placement="top"
              overlay={
                <Popover id="popover-component-display-name">
                  <PopoverBody
                    style={{
                      backgroundColor: "#000000",
                      color: "#ffffff",
                    }}
                  >
                    Move Component up.
                  </PopoverBody>
                </Popover>
              }
            >
              <button
                className="p-0 shadow-none btn"
                style={{
                  position: "absolute",
                  top: "-20px",
                  right: "40px",
                }}
                onClick={() => {
                  moveComponentUp();
                }}
              >
                <svg
                  width="40"
                  height="40"
                  viewBox="0 0 40 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#uyjfi5t5ba)">
                    <rect
                      x="32"
                      y="30"
                      width="24"
                      height="24"
                      rx="4"
                      transform="rotate(-180 32 30)"
                      fill="#fff"
                    />
                    <rect
                      x="31.5"
                      y="29.5"
                      width="23"
                      height="23"
                      rx="3.5"
                      transform="rotate(-180 31.5 29.5)"
                      stroke="#C9CCCF"
                    />
                  </g>
                  <path
                    d="m24 20-4-4-4 4"
                    stroke="#091CAA"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <defs>
                    <filter
                      id="uyjfi5t5ba"
                      x="0"
                      y="0"
                      width="40"
                      height="40"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="2" />
                      <feGaussianBlur stdDeviation="4" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
                      <feBlend
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_522_1354"
                      />
                      <feBlend
                        in="SourceGraphic"
                        in2="effect1_dropShadow_522_1354"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </button>
            </OverlayTrigger>
          )}
          <div className="container-fluid ps-5">
            <div className="mb-3 row">
              <div className="form-group col-md-3 ">
                <div className="tw-flex tw-items-center tw-text-center tw-gap-2">
                  <label className="pb-1">Display Name*</label>
                  <span className="tw-pb-0.5"><OverlayIcon message={DISPLAY_NAME_INFO}/></span>
                </div>
                
                <input
                  type="text"
                  className="shadow-none form-control border-1"
                  id="display_name"
                  style={{
                    fontSize: ".8rem",
                    color: "black",
                    fontWeight: "500",
                    fontFamily: "Noto Sans",
                    border: `1px solid ${
                      display_name && display_name.length > 0
                        ? "#ced4da"
                        : "#c13e25"
                    }`,
                  }}
                  placeholder="Enter Display Name"
                  value={display_name}
                  onChange={(e) =>
                    set_component_detail("display_name", e.target.value)
                  }
                />
              </div>
              <div className="form-group col-md-3">
                <div className="tw-flex tw-items-center tw-text-center tw-gap-2">
                  <label className="pb-1">Display Name*</label>
                  <span className="tw-pb-0.5"><OverlayIcon message={UNIQUE_NAME_INFO}/></span>
                </div>
                
                <input
                  type="text"
                  className="shadow-none form-control border-1"
                  id="unique_name"
                  style={{
                    fontSize: ".8rem",
                    color: "black",
                    fontWeight: "500",
                    fontFamily: "Noto Sans",
                    border: `1px solid ${
                      unique_name && unique_name.length > 0
                        ? "#ced4da"
                        : "#c13e25"
                    }`,
                  }}
                  placeholder="Enter Unique Name"
                  value={unique_name}
                  onChange={(e) =>
                    set_component_detail("unique_name", e.target.value)
                  }
                />
              </div>
              <div className="form-group col-md-2 col-sm-6">
                <label
                  className="pb-1"
                  style={{
                    fontWeight: "400",
                    fontFamily: "Noto Sans",
                  }}
                >
                  Necessary
                </label>
                <select
                  className="shadow-none form-select border-1"
                  id="nessie"
                  aria-label="Nessie"
                  value={nessie}
                  style={{
                    fontSize: ".8rem",
                    color: "black",
                    fontWeight: "500",
                    fontFamily: "Noto Sans",
                  }}
                  onChange={(e) =>
                    set_component_detail("nessie", e.target.value)
                  }
                >
                  <option value="REQUIRED">REQUIRED</option>
                  <option value="DEFAULT">DEFAULT</option>
                  <option value="OPTIONAL">OPTIONAL</option>
                </select>
              </div>
              <div className="col-md-1"></div>
              <div className="pt-3 col-md-3">
                <button
                  className="shadow-none btn float-end"
                  onClick={() => {
                    if (componentdetail?.component?.unique_name === "") {
                      removeComponent(position);
                    } else {
                      set_component_detail("is_deleted");
                    }
                  }}
                >
                  {componentdetail?.component?.is_deleted ? (
                    <RestoreIcon></RestoreIcon>
                  ) : (
                    <DeleteIcon></DeleteIcon>
                  )}
                </button>
              </div>
            </div>
            <div className="mb-2 row">
              <div className="form-group col-md-8 col-sm-6">
                <label
                  className="pb-1"
                  style={{
                    fontWeight: "400",
                    fontFamily: "Noto Sans",
                  }}
                >
                  Description
                </label>
                <textarea
                  type="text"
                  className="shadow-none form-control border-1"
                  id="description"
                  style={{
                    fontSize: ".8rem",
                    color: "black",
                    fontWeight: "500",
                    fontFamily: "Noto Sans",
                  }}
                  placeholder="Enter Component Description"
                  value={description}
                  onChange={(e) =>
                    set_component_detail("description", e.target.value)
                  }
                />
              </div>
            </div>
          </div>

          <div
            className="pt-3 pb-4 ps-5"
            style={{
              width: "90%",
            }}
          >
            {definition && (
              <div>
                <BuilderDefinition
                  componentDefinition={definition}
                  setUpdatedComponent={set_component_detail}
                />
              </div>
            )}
          </div>
        </div>
      }
    </React.Fragment>
  );
};
export default BuilderComponent;
